import { CancelToken } from 'axios';

import { resolveV3 } from '@/endpoints/resolveV3';
import DataResponse from '@/endpoints/types';

/** The different types of announcements */
export enum InAppAnnouncementType {
  PLATMAP_MODAL = 'plat-map-modal',
  ANNOUNCEMENT_BAR = 'announcement-bar',
  LEFT_SIDE_MODAL = 'left-side-modal',
}

interface IInAppAnnoucement {
  codename: string;
  cta_1_label: string;
  cta_1_url: string;
  cta_2_label: string;
  cta_2_url: string;
  disclaimer: string;
  days_hidden_after_initial_view: number;
  end: string;
  start: string;
  subtitle: string;
  title: string;
  type: InAppAnnouncementType;
}

export const getInAppAnnoucements = async (
  cancelToken: CancelToken
): Promise<DataResponse<IInAppAnnoucement[]>> => {
  return resolveV3(
    {
      cancelToken,
      url: '/management/announcements/',
    },
    {
      baseUrl: 'itasca',
    }
  );
};
